import moment from 'moment';

const useDateHook = () => {
  const formatDate = (date, format = 'DD/MM/YYYY') => moment(date).format(format);

  return {
    formatDate,
  };
};

export default useDateHook;

